import { render, staticRenderFns } from "./OnlineFormDetail.vue?vue&type=template&id=069a2748&"
import script from "./OnlineFormDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineFormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports